import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify"

import Layout from "../../layouts/layout"
import MainPageLayout from "../../components/main-page-layout/mainPageLayout"
import { useRequestProcessor } from "../../api/requestProcessor"
import { getAllCategories, storeSingleCategories } from "../../api/categories"


import Select from "react-select";
import makeAnimated from 'react-select/animated';


const CreateCategories = () => {

    const [name, setName] = useState("")
    const [category, setCategory] = useState("blog")
    const [selectedCategories, setSelectedCategories] = useState([])

    const navigate = useNavigate()
    const { Query, Mutate } = useRequestProcessor()

    const { data: categoriesData, } = Query(
        ['getAllUsersWithoutPaginate'],
        () => getAllCategories("all"),
    );

    const { mutate } = Mutate(
        "storeCategory",
        storeSingleCategories,
        {
            onSuccess: (data) => {
                successfulHandler(data) //This is the response you get back
            }
            ,
            onError: (data) => {
                toast.error(data.response.data.message)
            }
        }
    );


    function successfulHandler(res) {
        toast.success(res.message, {
            progress: false,
            autoClose: 2200,
        })
        toast.info("تا چند ثانیه دیگر به صفحه اصلی منتقل میشوید", {
            autoClose: 2500,
            pauseOnHover: false
        })
        setTimeout(() => { navigate("/admin/categories") }, 3000)
    }

    async function onSubmitHandler(e) {
        e.preventDefault();
        let data = {
            title: name,
            type: category,
            parent_id:selectedCategories.map(el => (el.value))[0] ?? null
        }
        mutate(data)
    }

    const animatedComponents = makeAnimated();
    function handleOnChangeWorkshop(data) {
        setSelectedCategories(data)
    }

    return (
        <Layout >
            <MainPageLayout backButton sectionTitle={"مشخصات دسته بندی :"} title={"ایجاد دسته بندی جدید"} >
                <form onSubmit={onSubmitHandler}>
                    <div className="flex w-full">

                        <div className='flex w-full flex-col my-4 ml-4 wsm:!ml-0'>
                            <div className='flex flex-col my-3'>
                                <p className='pr-3 pb-1'>نام دسته بندی :</p>
                                <input type="text" value={name} onChange={(e) => setName(e.target.value)} className=' !w-full form-input' placeholder='نام دسته بندی' />
                            </div>
                            <div className="flex flex-col my-3">
                                <p className='pr-3 pb-1'>نوع دسته بندی :</p>
                                <select value={category} onChange={e => setCategory(e.target.value)} className="!w-full border border-gray-500 py-[10px] px-[20px] rounded-[10px] focus:border-[#1976d2bf]" >
                                    <option selected disabled hidden>انتخاب نوع دسته</option>
                                    <option value={"blog"} >بلاگ</option>
                                    <option value={"workshop"} >ورک شاپ</option>
                                    <option value={"course"} >دوره</option>
                                </select>
                            </div>
                        </div>
                        <div className="flex flex-col w-full my-4">
                            <div className='flex flex-col my-3'>
                                <p className='pr-3 pb-1'>انتخاب دسته بندی والد :</p>
                                <Select components={animatedComponents} placeholder="انتخاب کنید..." styles={{ zIndex: "-1" }}
                                    onChange={handleOnChangeWorkshop} closeMenuOnSelect={false} value={selectedCategories} isMulti isOptionDisabled={() => selectedCategories.length >= 1}
                                    options={categoriesData?.data?.map(el => ({ label: el.title, value: el.id }))}
                                />
                            </div>
                        </div>
                    </div>
                    <div id='form-add-button--container'>
                        <button type="submit" id='form-add-button'>ثبت</button>
                    </div>
                </form>
            </MainPageLayout>
        </Layout>
    )
}

export default CreateCategories